export default __webpack_public_path__ + "static/footer-image-188595ebaa50ad42ad4b49a31b32a488.png";